<template>
  <div class="login-page ">
    <pageHeader />
    <section class="start">
      <div class="right-sec sec min-mobile">
        <div class="content1 auth-center">
          <div class="form-co">
            <div class="info">
              <h4>{{ $t('auth.login') }}</h4>
              <p class="gray-col font14">
                {{ $t('auth.loginPhase') }}
              </p>
            </div>
            <v-form @submit.prevent="ValidLogin" v-model="valid" ref="form">
              <div class="main-input-cont mt-1 tel-input-me">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.phone') }}</h6>
                <v-text-field
                  v-model="phone"
                  type="number"
                  name="phone"
                  min="0"
                  :rules="phoneRules"
                  :placeholder="$t('auth.phoneplace')"
                ></v-text-field>
                <div class="drop-countries">
                  <Dropdown
                    v-model="selectedCountry"
                    :options="countries"
                    optionLabel="name"
                  >
                    <template #value="slotProps">
                      <div v-if="slotProps.value" class="flex-group-me">
                        <img
                          :alt="slotProps.value.label"
                          :src="slotProps.value.image"
                          :class="`mr-2 flag flag-${slotProps.value.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.value.key }}</div>
                      </div>
                      <span v-else>
                        {{ slotProps.placeholder }}
                      </span>
                    </template>
                    <template #option="slotProps">
                      <div class="flex-group-me">
                        <img
                          :alt="slotProps.option.label"
                          :src="slotProps.option.image"
                          :class="`mr-2 flag flag-${slotProps.option.key.toLowerCase()}`"
                          style="width: 24px"
                        />
                        <div>{{ slotProps.option.key }}</div>
                      </div>
                    </template>
                  </Dropdown>
                </div>
              </div>
              <div class="main-input-cont mt-1">
                <h6 class="mb-2 font14 requiredInputLabel">{{ $t('auth.password') }}</h6>
                <v-text-field
                  v-model="password"
                  type="password"
                  name="password"
                  :rules="rules"
                  :placeholder="$t('auth.passwordplace')"
                ></v-text-field>
                <div
                  class="absLeft pointer-click"
                  @click="toogleEyeIcon($event)"
                >
                  <div class="normalEye">
                    <i class="fa-regular fa-eye"></i>
                  </div>
                  <div class="slashedEye">
                    <i class="fa-regular fa-eye-slash"></i>
                  </div>
                </div>
              </div>

              <div class="link font14 mb-3 gray-col">
                <router-link to="/forgetPassword"
                  >{{ $t('auth.forget') }}</router-link
                >
              </div>

              <button
                type="submit"
                :disabled="disabled"
                class="main-btn up xl w-100"
              >
                <div v-if="!disabled">{{ $t('auth.login') }}</div>
                <div class="loading" role="status" v-if="disabled">
                  {{ $t('auth.loginLoader') }}
                  <div class="spinner-small-white" v-if="disabled"></div>
                </div>
              </button>
              <div class="flex-group-me mt-3">
                <div class="dont-have font14 gray-col">
                  {{ $t('auth.donthave') }}
                  <router-link to="/registerView">{{ $t('auth.click') }}</router-link>
                </div>
              </div>
            </v-form>
          </div>
        </div>
      </div>
      <welcomeView />
    </section>
  </div>
</template>

<script setup>
import pageHeader from "../components/pageHeader.vue";
import welcomeView from "../components/home/welcomeView.vue";
import Dropdown from "primevue/dropdown";
import { ref, onMounted } from "vue";
import axios from "axios";
import { useToast } from "primevue/usetoast";
import { useRouter } from "vue-router";
const toast = useToast();
const router = useRouter();
import i18n from "@/i18n";

const selectedCountry = ref({
  key: "+966",
  code: "SA",
  image:
    "http://backend.saqf-sa.com/public/storage/images/countries/1704282290_8447.png",
});
const countries = ref([]);

const password = ref("");
const phone = ref("");
const valid = ref(false);
const form = ref(null);
const disabled = ref(false);
const rules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.passValid`);
  },
]);
const phoneRules = ref([
  (value) => {
    if (value) return true;

    return i18n.global.t(`auth.phoneValid`);
  },
  (value) => {
    if (value.length >= 9) return true;

    return i18n.global.t(`auth.phoneValidnumber`);
  },
]);

// functions

function getCountries() {
  axios.get("/countries").then((response) => {
    countries.value = response.data.data;
    selectedCountry.value = response.data.data?.find(
      (country) => country.key == "+966"
    ) || response.data.data[0];
  });
}
function login() {
  disabled.value = true;
  const fd = new FormData(form.value.$el);
  // fd.append("type", SendedVal.value);
  fd.append("country_code", selectedCountry.value.key);
  fd.append("device_id", "111");
  fd.append("device_type", "web");
  fd.append("lang", localStorage.getItem("locale"));

  axios.post("/manager/sign-in", fd).then((response) => {
    if (response.data.key == "success") {
      localStorage.setItem("phone", phone.value);
      localStorage.setItem("country_code", selectedCountry.value.key);
      localStorage.setItem("country_img", selectedCountry.value.image);
      localStorage.setItem("token", response.data.data.token);
      localStorage.setItem("visitorId", response.data.data.id);
      // user name and image 
      localStorage.setItem("userName", response.data.data.name);
      localStorage.setItem("userImage", response.data.data.image);
      toast.add({
        severity: "success",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/dashboardHome");
    } else if (response.data.key == "needActive"){
      localStorage.setItem("phone", phone.value);
      localStorage.setItem("country_code", selectedCountry.value?.key);
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
      router.push("/keyCode");

    } else {
      toast.add({
        severity: "error",
        detail: `${response.data.msg}`,
        life: 3000,
      });
    }
    disabled.value = false;
  });
}
function ValidLogin() {
  if (valid.value) {
    login();
  }
}

// toggle input type
function toogleEyeIcon(event) {
  event.currentTarget.classList.toggle("toggleEye");
  let currentType = event.currentTarget.previousElementSibling
    .querySelector("input")
    .getAttribute("type");
  console.log(currentType);
  if (currentType == "text") {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "password");
  } else {
    event.currentTarget.previousElementSibling
      .querySelector("input")
      .setAttribute("type", "text");
  }
}

onMounted(() => {
  getCountries();
  
  // Check if there's a blocked message to show
  const blockedMessage = localStorage.getItem("blockedMessage");
  const redirectToLogin = localStorage.getItem("redirectToLogin");
  
  if (blockedMessage && redirectToLogin === "true") {
    toast.add({
      severity: "error",
      detail: blockedMessage,
      life: 3000,
    });
    
    // Clear the stored data
    localStorage.removeItem("blockedMessage");
    localStorage.removeItem("redirectToLogin");
    
    // Use router to navigate if we're not already on login page
    if (router.currentRoute.value.path !== "/loginView") {
      router.push("/loginView");
    }
  }
});
</script>
